import { Component, OnInit, ElementRef, Inject, PLATFORM_ID, OnDestroy, ViewEncapsulation } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { Meta, Title } from '@angular/platform-browser'
import { SEOService, SharedService } from '@flowaccount/landing'
import { isPlatformBrowser } from '@angular/common'
import { Store } from '@ngrx/store'
import { Observable, Subscription } from 'rxjs'
import { IAppState } from '@flowaccount/landing'
import { ActivatedRoute } from '@angular/router'
import { Pages } from '../../../models/blog.model'
import videoData from '../../../../assets/ultimateguide/ultimateguide.json'
import { tutorialsJSONLD } from '../../../models/structuredData/index'
import { Subject } from 'rxjs'
import { GuideRoutingService } from '../service/guide-routing.service'
import { environment } from '../../../../environments/environment'

@Component({
  selector: 'flowaccount-ultimateguide',
  templateUrl: './ultimateguide.component.html',
  styleUrls: ['./ultimateguide.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class UltimateGuideComponent implements OnInit, OnDestroy {
  public isMobileResolution: Observable<boolean>
  page = Pages
  customHeader = {
    heading: 'BLOG_SWIPER_TOPIC.HEADING_ULTIMATEGUIDE',
    detail: 'BLOG_SWIPER_TOPIC.DETAIL_ULTIMATEGUIDE',
  }

  public ul1: Array<any> = []
  public ul2: Array<any> = []
  public ul3: Array<any> = []
  public ul4: Array<any> = []
  public ul5: Array<any> = []
  public ul6: Array<any> = []
  public ul7: Array<any> = []
  public ul8: Array<any> = []

  public tutorialsLD = tutorialsJSONLD
  public ngUnSubScribe = new Subject()

  public numberOfSmallBusiness
  private langChangeSubscription: Subscription
  constructor(
    private _translate: TranslateService,
    private route: ActivatedRoute,
    private titleService: Title,
    private seoService: SEOService,
    public translate: TranslateService,
    private elementRef: ElementRef,
    public sharedService: SharedService,
    @Inject(PLATFORM_ID) private platformId,
    private store: Store<{ appState: IAppState }>,
    private guideRoutingService: GuideRoutingService,
    private meta: Meta,
  ) {
    this.isMobileResolution = this.store.select((s) => s.appState.isMobile)
    this.langChangeSubscription = this.translate.onLangChange.subscribe(() => {
      this.setMeta()
    })
  }

  setMeta() {
    const title = this.translate.instant('metatitle')
    const description = this.translate.instant('metaDescription')
    const imageUrl = 'https://flowaccountcdn.com/new_landing/image/UltimateGuide/Ultimate_head_1.jpg'

    this.titleService.setTitle(title)
    this.seoService.createMetaTag(title, description)
    this.seoService.createOg(imageUrl, title, description)
  }
  ngOnDestroy() {
    this.ngUnSubScribe.next(undefined)
    this.ngUnSubScribe.complete()
    this.langChangeSubscription?.unsubscribe()
  }
  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.loadScript()
    }
    const allVideo = videoData.allVideo
    this.ul1 = allVideo.filter((item) => item.catagory === 1)
    this.ul2 = allVideo.filter((item) => item.catagory === 2)
    this.ul3 = allVideo.filter((item) => item.catagory === 3)
    this.ul4 = allVideo.filter((item) => item.catagory === 4)
    this.ul5 = allVideo.filter((item) => item.catagory === 5)
    this.ul6 = allVideo.filter((item) => item.catagory === 6)
    this.ul7 = allVideo.filter((item) => item.catagory === 7)
    this.ul8 = allVideo.filter((item) => item.catagory === 8)

    this.numberOfSmallBusiness = {
      numberOfSmallBusiness: environment.numberOfSmallBusiness,
    }
  }

  goToPositions() {
    if (isPlatformBrowser(this.platformId)) {
      const target = document.querySelector('.positions')
      target.scrollIntoView({ behavior: 'smooth' })
    }
  }

  loadScript() {
    const arrayJsonLD = [this.tutorialsLD]
    for (let i = 0; i < arrayJsonLD.length; i++) {
      const itemJsonLD = arrayJsonLD[i] ? JSON.stringify(arrayJsonLD[i], null, 2).replace(/\//g, '\\/') : ''
      const node = document.createElement('script')
      node.type = 'application/ld+json'
      const text = document.createTextNode(itemJsonLD)
      node.appendChild(text)
      document.getElementsByTagName('head')[0].appendChild(node)
    }
  }
}
